 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1THEREINCARNATIONOFAREBORNSTAR from '@/components/0_chapter1thereincarnationofarebornstar'
 import A_CHAPTER2BIRTH from '@/components/1_chapter2birth'
 import A_CHAPTER3CAPITALMEASUREMENT from '@/components/2_chapter3capitalmeasurement'
 import A_CHAPTER4ALTERINGMUSCLEMERIDIAN from '@/components/3_chapter4alteringmusclemeridian'
 import A_CHAPTER5ACUPUNCTUREANDMOXIBUSTIONNEEDLINGPOINT from '@/components/4_chapter5acupunctureandmoxibustionneedlingpoint'
 import A_CHAPTER6XUANYUANZHEN from '@/components/5_chapter6xuanyuanzhen'
 import A_CHAPTER7ENEMIESHAVEANARROWROAD from '@/components/6_chapter7enemieshaveanarrowroad'
 import A_CHAPTER8TIBETANMERIDIANPAVILION from '@/components/7_chapter8tibetanmeridianpavilion'
 import A_CHAPTER9HUNTING from '@/components/8_chapter9hunting'
 import A_CHAPTER10NANGONGXINER from '@/components/9_chapter10nangongxiner'
 import A0_CHAPTER11GRADEFIVEVICIOUSBEAST from '@/components/10_chapter11gradefiveviciousbeast'
 import A1_CHAPTER12THEBATTLEBETWEENTHEFIFTHLEVELVICIOUSBEASTS from '@/components/11_chapter12thebattlebetweenthefifthlevelviciousbeasts'
 import A2_CHAPTER13THEMANTISSTALKSTHECICADAANDTHEORIOLE from '@/components/12_chapter13themantisstalksthecicadaandtheoriole'
 import A3_CHAPTER14COUNTERATTACK from '@/components/13_chapter14counterattack'
 import A4_CHAPTER15THOUSANDYEARSOLDCINNABARFRUIT from '@/components/14_chapter15thousandyearsoldcinnabarfruit'
 import A5_CHAPTER16WUQINGLUO from '@/components/15_chapter16wuqingluo'
 import A6_CHAPTER17AUCTION from '@/components/16_chapter17auction'
 import A7_CHAPTER18PLEASECHERISH from '@/components/17_chapter18pleasecherish'
 import A8_CHAPTER19ANNUALSESSION from '@/components/18_chapter19annualsession'
 import A9_CHAPTER20YANGYAN from '@/components/19_chapter20yangyan'
 import A0_CHAPTER21ANNUALLARGECOMPETITION from '@/components/20_chapter21annuallargecompetition'
 import A1_CHAPTER22QINGER from '@/components/21_chapter22qinger'
 import A2_CHAPTER23STRIKE from '@/components/22_chapter23strike'
 import A3_CHAPTER24FIGHTLUOHUA from '@/components/23_chapter24fightluohua'
 import A4_CHAPTER25REALSTRENGTH from '@/components/24_chapter25realstrength'
 import A5_CHAPTER26FIRSTINTHELARGECOMPETITION from '@/components/25_chapter26firstinthelargecompetition'
 import A6_CHAPTER27REENTRYINTOTHESCRIPTUREPAVILION from '@/components/26_chapter27reentryintothescripturepavilion'
 import A7_CHAPTER28FLAMEDEVOURINGBODYREFININGTECHNIQUE from '@/components/27_chapter28flamedevouringbodyrefiningtechnique'
 import A8_CHAPTER29BLACKEGGMUTATION from '@/components/28_chapter29blackeggmutation'
 import A9_CHAPTER30ASKEDTOFIGHTAUTUMNMOON from '@/components/29_chapter30askedtofightautumnmoon'
 import A0_CHAPTER31STAGEFRIGHT from '@/components/30_chapter31stagefright'
 import A1_CHAPTER32FORCINGTHEDUOPRIDES from '@/components/31_chapter32forcingtheduoprides'
 import A2_CHAPTER33STUNNINGFOURSEALS from '@/components/32_chapter33stunningfourseals'
 import A3_CHAPTER34HISNAMESHOOKTHEENTIREBAILU from '@/components/33_chapter34hisnameshooktheentirebailu'
 import A4_CHAPTER35STRANGEBLACKEGG from '@/components/34_chapter35strangeblackegg'
 import A5_CHAPTER36FIRESEED from '@/components/35_chapter36fireseed'
 import A6_CHAPTER37ASSAULTANDKILLING from '@/components/36_chapter37assaultandkilling'
 import A7_CHAPTER38BLOODSPIRITMONKEY from '@/components/37_chapter38bloodspiritmonkey'
 import A8_CHAPTER39MONKEYKING from '@/components/38_chapter39monkeyking'
 import A9_CHAPTER40TENTATIVEWINDANDRAIN from '@/components/39_chapter40tentativewindandrain'
 import A0_CHAPTER41UNDERCURRENTSURGE from '@/components/40_chapter41undercurrentsurge'
 import A1_CHAPTER42DYINGSTRUGGLE from '@/components/41_chapter42dyingstruggle'
 import A2_CHAPTER43FISTINTENT from '@/components/42_chapter43fistintent'
 import A3_CHAPTER44WARMKILLING from '@/components/43_chapter44warmkilling'
 import A4_CHAPTER45BLOODSPLATTEREDMANDARINDUCKHOUSE from '@/components/44_chapter45bloodsplatteredmandarinduckhouse'
 import A5_CHAPTER46SEEINGAMOUNTAINISNOTAMOUNTAIN from '@/components/45_chapter46seeingamountainisnotamountain'
 import A6_CHAPTER47PERFECTIONOFMOVEMENT from '@/components/46_chapter47perfectionofmovement'
 import A7_CHAPTER48THETERRIFYINGGRADENINEVICIOUSBEAST from '@/components/47_chapter48theterrifyinggradenineviciousbeast'
 import A8_CHAPTER49CORIOLINAFRUCTUS from '@/components/48_chapter49coriolinafructus'
 import A9_CHAPTER50CROSSINGTHEHEAVENLYTRIBULATION from '@/components/49_chapter50crossingtheheavenlytribulation'
 import A0_CHAPTER51MUTATION from '@/components/50_chapter51mutation'
 import A1_CHAPTER52FLOODDRAGON from '@/components/51_chapter52flooddragon'
 import A2_CHAPTER53HATCHING from '@/components/52_chapter53hatching'
 import A3_CHAPTER54PHOENIX from '@/components/53_chapter54phoenix'
 import A4_CHAPTER55BREAKOUTCROW from '@/components/54_chapter55breakoutcrow'
 import A5_CHAPTER56LUCIFERA from '@/components/55_chapter56lucifera'
 import A6_CHAPTER57TIANJI from '@/components/56_chapter57tianji'
 import A7_CHAPTER58ACHAOTICWORLDISABOUTTOBREAKOUT from '@/components/57_chapter58achaoticworldisabouttobreakout'
 import A8_CHAPTER59THUNDERFLAMEBODYREFINEMENT from '@/components/58_chapter59thunderflamebodyrefinement'
 import A9_CHAPTER60BREAKTHROUGHFLAMESEA from '@/components/59_chapter60breakthroughflamesea'
 import A0_CHAPTER61SAVETHEMONKEYKING from '@/components/60_chapter61savethemonkeyking'
 import A1_CHAPTER62DETOXIFICATION from '@/components/61_chapter62detoxification'
 import A2_CHAPTER63CALMNESSOFWINDANDRAIN from '@/components/62_chapter63calmnessofwindandrain'
 import A3_CHAPTER64MONKEYWINE from '@/components/63_chapter64monkeywine'
 import A4_CHAPTER65FIVEBIRDBODYFORGINGTECHNIQUE from '@/components/64_chapter65fivebirdbodyforgingtechnique'
 import A5_CHAPTER66BESIEGED from '@/components/65_chapter66besieged'
 import A6_CHAPTER67BATTLEOFTHENINESTAGES from '@/components/66_chapter67battleoftheninestages'
 import A7_CHAPTER68BATTLECONSCIOUSNESS from '@/components/67_chapter68battleconsciousness'
 import A8_CHAPTER69THUNDERFLAMEBEASTFIRE from '@/components/68_chapter69thunderflamebeastfire'
 import A9_CHAPTER70LINEOFLIFEANDDEATH from '@/components/69_chapter70lineoflifeanddeath'
 import A0_CHAPTER71MERCENARYGROUP from '@/components/70_chapter71mercenarygroup'
 import A1_CHAPTER72QUIRKYGREATBOW from '@/components/71_chapter72quirkygreatbow'
 import A2_CHAPTER73OCTAGONANISEED from '@/components/72_chapter73octagonaniseed'
 import A3_CHAPTER74SKYCAVERN from '@/components/73_chapter74skycavern'
 import A4_CHAPTER75CONVERGENCE from '@/components/74_chapter75convergence'
 import A5_CHAPTER76DREADFULSKYCAVERN from '@/components/75_chapter76dreadfulskycavern'
 import A6_CHAPTER77LUOYUWENTDOWNTHESKYCAVERN from '@/components/76_chapter77luoyuwentdowntheskycavern'
 import A7_CHAPTER78FIREBAT from '@/components/77_chapter78firebat'
 import A8_CHAPTER79QINGERWASINDANGER from '@/components/78_chapter79qingerwasindanger'
 import A9_CHAPTER80YOURENOTHUMAN from '@/components/79_chapter80yourenothuman'
 import A0_CHAPTER81AURAPRESSURE from '@/components/80_chapter81aurapressure'
 import A1_CHAPTER82PSYCHICBODYWITHSEVENAPERTURES from '@/components/81_chapter82psychicbodywithsevenapertures'
 import A2_CHAPTER83THETHIRDSTAGEOFINNATE from '@/components/82_chapter83thethirdstageofinnate'
 import A3_CHAPTER84SHEEPNOITWASTHEWOLF from '@/components/83_chapter84sheepnoitwasthewolf'
 import A4_CHAPTER85IMSORRY from '@/components/84_chapter85imsorry'
 import A5_CHAPTER86AZUREDRAGONKING from '@/components/85_chapter86azuredragonking'
 import A6_CHAPTER87DEPARTUREOFAWOMANONADRAGON from '@/components/86_chapter87departureofawomanonadragon'
 import A7_CHAPTER88RENYU from '@/components/87_chapter88renyu'
 import A8_CHAPTER89DEEP from '@/components/88_chapter89deep'
 import A9_CHAPTER90CRIMSONFIREDEVILBAT from '@/components/89_chapter90crimsonfiredevilbat'
 import A0_CHAPTER91WARDEMONICBEAST from '@/components/90_chapter91wardemonicbeast'
 import A1_CHAPTER92TEQUILASHOWINGITSMIGHT from '@/components/91_chapter92tequilashowingitsmight'
 import A2_CHAPTER93EXCAVATION from '@/components/92_chapter93excavation'
 import A3_CHAPTER94HARVESTLEAVE from '@/components/93_chapter94harvestleave'
 import A4_CHAPTER95TOUCH from '@/components/94_chapter95touch'
 import A5_CHAPTER96THOUSANDMENFIGHTING from '@/components/95_chapter96thousandmenfighting'
 import A6_CHAPTER97BLOODFIGHTING from '@/components/96_chapter97bloodfighting'
 import A7_CHAPTER98BLOODYRUTHLESSNESS from '@/components/97_chapter98bloodyruthlessness'
 import A8_CHAPTER99THEMIGHTOFTHEWARBEAST from '@/components/98_chapter99themightofthewarbeast'
 import A9_CHAPTER100HEHADTOSUPPRESSTHEENTIREAUDIENCEWITHFORCE from '@/components/99_chapter100hehadtosuppresstheentireaudiencewithforce'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1thereincarnationofarebornstar",
 			"name" : "0_chapter1thereincarnationofarebornstar",
 			"component" : A_CHAPTER1THEREINCARNATIONOFAREBORNSTAR
 		},
 		{
 			"path" : "/1_chapter2birth",
 			"name" : "1_chapter2birth",
 			"component" : A_CHAPTER2BIRTH
 		},
 		{
 			"path" : "/2_chapter3capitalmeasurement",
 			"name" : "2_chapter3capitalmeasurement",
 			"component" : A_CHAPTER3CAPITALMEASUREMENT
 		},
 		{
 			"path" : "/3_chapter4alteringmusclemeridian",
 			"name" : "3_chapter4alteringmusclemeridian",
 			"component" : A_CHAPTER4ALTERINGMUSCLEMERIDIAN
 		},
 		{
 			"path" : "/4_chapter5acupunctureandmoxibustionneedlingpoint",
 			"name" : "4_chapter5acupunctureandmoxibustionneedlingpoint",
 			"component" : A_CHAPTER5ACUPUNCTUREANDMOXIBUSTIONNEEDLINGPOINT
 		},
 		{
 			"path" : "/5_chapter6xuanyuanzhen",
 			"name" : "5_chapter6xuanyuanzhen",
 			"component" : A_CHAPTER6XUANYUANZHEN
 		},
 		{
 			"path" : "/6_chapter7enemieshaveanarrowroad",
 			"name" : "6_chapter7enemieshaveanarrowroad",
 			"component" : A_CHAPTER7ENEMIESHAVEANARROWROAD
 		},
 		{
 			"path" : "/7_chapter8tibetanmeridianpavilion",
 			"name" : "7_chapter8tibetanmeridianpavilion",
 			"component" : A_CHAPTER8TIBETANMERIDIANPAVILION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js